import React, { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface AdminPageHeaderProps {
  title: string;
  subtitle?: string;
  backPath?: string;
  actions?: ReactNode;
}

/**
 * AdminPageHeader - Header component for admin pages
 * Includes title, optional back button, and action buttons
 */
export const AdminPageHeader: React.FC<AdminPageHeaderProps> = ({
  title,
  subtitle,
  backPath,
  actions,
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
      <div className="flex items-center gap-4">
        {backPath && (
          <button
            onClick={() => navigate(backPath)}
            className="
              p-2
              text-[#888888]
              hover:text-white
              hover:bg-[#333333]
              rounded-lg
              transition-colors
            "
            aria-label="Voltar"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        )}
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-white">
            {title}
          </h1>
          {subtitle && (
            <p className="text-[#888888] text-sm mt-1">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {actions && (
        <div className="flex items-center gap-3">
          {actions}
        </div>
      )}
    </div>
  );
};

export default AdminPageHeader;
